/**
 * Device Types store
 * @module store/device-types
 */


import { createStore, createHook } from '@thermon-platforms/react-sweet-state';
import api from 'util/api';

// define store initial state
const initialState = {
  types: [],
  loading: false,
  error: undefined,
  updated: undefined
};
// define the actions that mutate the state
export const actions = {
  query: (force = false) => async ({ getState, setState }) => {
    const now = Date.now();
    const currentState = getState();
    // If we're already loading alarms or the current data is still fresh, return
    if (!force && (currentState.loading || (now - currentState.updated) < (60 * 1000))) return;
    setState({ loading: true });
    try {
      // Fetch our data
      const res = await api('/devices/types');
      // and unwrap it
      const types = await res.json();

      setState({ types, loading: false,  updated: Date.now() });
    } catch (error) {
      console.error(error);
      // If that fails, update our state with the error
      setState({ error, loading: false, updated: Date.now() });
    }
  }
}

// create a store type
const Store = createStore({ initialState, actions });

// create components to access store state instances
const useStore = createHook(Store);

/**
 * Expose hooks for store
 * @function useStore
 * @memberof module:store/device-types
 * @example
 * const [deviceTypesStore, deviceTypesStoreActions] = useDeviceTypesStore();
 */
export default useStore;
